import { useCallback, useEffect } from 'react';
import { useAuthStore, useMagic } from '@package/smart-wallet';
import { useConnectWallet } from '@package/smart-wallet/hooks';

/* Hooks */
export const useConnectAccount = () => {
  const { magic } = useMagic();
  const { signUp } = useAuthStore();
  const { handleConnect, isLoading, isConnected } = useConnectWallet();

  /* Callbacks */
  const getUserEmail = useCallback(async () => {
    if (!magic?.user?.getInfo) return;
    const user = await magic?.user.getInfo();
    if (!user?.email) return;
    signUp(user.email);
  }, [magic, signUp]);

  /* Effects */
  useEffect(() => {
    if (!magic?.user?.getInfo) return;
    getUserEmail();
  }, [magic, getUserEmail]);

  /* Return */
  return {
    handleConnect,
    isLoading,
    isConnected,
  };
};
